import type { SnsPlatform } from 'store/apiTypes';

// Constants for MyReview Page
const CLICK_LIKE_PROVIDER_MY_REVIEW_SP = 'click_like_provider_my_review_page_sp';
const CLICK_LIKE_PROVIDER_MY_REVIEW_PC = 'click_like_provider_my_review_page_pc';

const CLICK_UNLIKE_PROVIDER_MY_REVIEW_SP = 'click_unlike_provider_my_review_page_sp';
const CLICK_UNLIKE_PROVIDER_MY_REVIEW_PC = 'click_unlike_provider_my_review_page_pc';

const CLICK_SNS_MY_REVIEW_SP = (sns_name) => `click_sns_${sns_name}_my_review_page_sp`;
const CLICK_SNS_MY_REVIEW_PC = (sns_name) => `click_sns_${sns_name}_my_review_page_pc`;

// Constants for Provider Review Page
const CLICK_LIKE_PROVIDER_REVIEW_SP = 'click_like_provider_review_page_sp';
const CLICK_LIKE_PROVIDER_REVIEW_PC = 'click_like_provider_review_page_pc';

const CLICK_UNLIKE_PROVIDER_REVIEW_SP = 'click_unlike_provider_review_page_sp';
const CLICK_UNLIKE_PROVIDER_REVIEW_PC = 'click_unlike_provider_review_page_pc';

// PROVIDER REVIEW AB TESTING
export const PROVIDER_REVIEW_AB_TESTING = 'guestReview_t1';
export const POST_REVIEW_AB_TESTING = 'guestReviewPosting_t1';
export const AB_TESTING_VALUE = 'trvab_1';

// REVIEW POST PAGE AB TESTING
export const REVIEW_POST_AB_TESTING_A = 'guestReviewPosting_t1_A';
export const REVIEW_POST_AB_TESTING_B = 'guestReviewPosting_t1_B';

export type GUEST_REVIEW_PAGE_NAME = 'MY_REVIEW_PAGE' | 'PROVIDER_REVIEW_PAGE' | 'REVIEW_POST_PAGE';
export const ACTION_LIKE = 'like';
export const ACTION_UNLIKE = 'unlike';
export const ACTION_SNS = 'sns';

export const MEDIA_REVIEW_POST = 'Media';
export const INVALID_FILE = 'invalidFile';
export const INVALID_FILE_SIZE = 'invalidFileSize';
export const MANY_FILES = 'manyFiles';
const MEDIA_REVIEW_POST_INVALID_FILE_PC = 'error_invalid_file_type_pc';
const MEDIA_REVIEW_POST_INVALID_FILE_SP = 'error_invalid_file_type_sp';
const MEDIA_REVIEW_POST_INVALID_FILE_SIZE_SP = 'error_invalid_file_size_sp';
const MEDIA_REVIEW_POST_INVALID_FILE_SIZE_PC = 'error_invalid_file_size_pc';
const MEDIA_REVIEW_POST_MANY_FILES_SP = 'error_many_files_sp';
const MEDIA_REVIEW_POST_MANY_FILES_PC = 'error_many_files_pc';

export const MY_REVIEW_PAGE = 'MY_REVIEW_PAGE';
export const PROVIDER_REVIEW_PAGE = 'PROVIDER_REVIEW_PAGE';
export const REVIEW_POST_PAGE = 'REVIEW_POST_PAGE';
export const MY_REVIEW = 'MY_REVIEW';

export const generateABTestRatParameters = (keyPattern: string, valuePattern: string) => {
  return {
    [keyPattern]: `${PROVIDER_REVIEW_AB_TESTING}_${valuePattern}`,
  };
};

export const generateABPostPageRatParameters = (keyPattern: string, valuePattern: string) => {
  return {
    [keyPattern]: `${POST_REVIEW_AB_TESTING}_${valuePattern}`,
  };
};

export const generateRatId = (
  action: string,
  pageName: string,
  isPC: boolean,
  platform?: SnsPlatform,
): any => {
  const platformValue = platform && platform.toLowerCase();

  switch (pageName) {
    case MY_REVIEW_PAGE:
      {
        if (action === ACTION_LIKE) {
          return !isPC ? CLICK_LIKE_PROVIDER_MY_REVIEW_SP : CLICK_LIKE_PROVIDER_MY_REVIEW_PC;
        } else if (action === ACTION_UNLIKE) {
          return !isPC ? CLICK_UNLIKE_PROVIDER_MY_REVIEW_SP : CLICK_UNLIKE_PROVIDER_MY_REVIEW_PC;
        } else if (action === ACTION_SNS) {
          return !isPC
            ? CLICK_SNS_MY_REVIEW_SP(platformValue)
            : CLICK_SNS_MY_REVIEW_PC(platformValue);
        }
      }

      break;
    case PROVIDER_REVIEW_PAGE:
      {
        if (action === ACTION_LIKE) {
          return !isPC ? CLICK_LIKE_PROVIDER_REVIEW_SP : CLICK_LIKE_PROVIDER_REVIEW_PC;
        } else if (action === ACTION_UNLIKE) {
          return !isPC ? CLICK_UNLIKE_PROVIDER_REVIEW_SP : CLICK_UNLIKE_PROVIDER_REVIEW_PC;
        }
      }

      break;
    case REVIEW_POST_PAGE:
      {
        if (action === INVALID_FILE) {
          return !isPC ? MEDIA_REVIEW_POST_INVALID_FILE_SP : MEDIA_REVIEW_POST_INVALID_FILE_PC;
        } else if (action === INVALID_FILE_SIZE) {
          return !isPC
            ? MEDIA_REVIEW_POST_INVALID_FILE_SIZE_SP
            : MEDIA_REVIEW_POST_INVALID_FILE_SIZE_PC;
        } else if (action === MANY_FILES) {
          return !isPC ? MEDIA_REVIEW_POST_MANY_FILES_SP : MEDIA_REVIEW_POST_MANY_FILES_PC;
        }
      }

      break;

    default: {
      throw new Error(`Unknown pageName: ${pageName}`);
    }
  }
};
